import { gql } from '@apollo/client';

export const FETCH_BULK_UPSERT_REQUEST = gql`
  query fetchBulkUpsertRequest($bulkUpsertRequestId: ObjectID!) {
    fetchBulkUpsertRequest(bulkUpsertRequestId: $bulkUpsertRequestId) {
      bulkUpsertRequest {
        id
        integration {
          id
        }
        state
        createdAt
        objectType
        queuedItemsCount
        failedItemsCount
        processedItemsCount
        organizationUser {
          id
          firstName
          lastName
        }
        apiToken {
          id
          name
        }
      }
    }
  }
`;
